/**
 * Formation strip above the pitch: each team's kit + formation + coach, mirrored, with a
 * centered FORMATION label.
 */

import React from 'react';
import { Text, View } from 'react-native';
import { SoccerKit } from '../../ui/SoccerKit';
import type { MatchHubTeamSide } from '../../../src/match/types/matchHub.types';
import type { MatchHubLineupsStyles } from './MatchHubLineupsPanel.styles';

function FormationBadge({
  team,
  formation,
  coach,
  styles,
  away,
}: {
  team: MatchHubTeamSide;
  formation: string;
  coach: string;
  styles: MatchHubLineupsStyles;
  away?: boolean;
}) {
  return (
    <View style={[styles.formBadge, away && styles.formBadgeAway]}>
      <SoccerKit primary={team.kit.primary} secondary={team.kit.secondary} type={team.kit.type} size={30} />
      <View style={[styles.formBadgeText, away && styles.formBadgeTextAway]}>
        <Text style={styles.formNum}>{formation}</Text>
        {coach !== '' && (
          <Text style={styles.formMgr} numberOfLines={1}>
            {coach}
          </Text>
        )}
      </View>
    </View>
  );
}

export interface MatchHubLineupsFormationStripProps {
  home: MatchHubTeamSide;
  away: MatchHubTeamSide;
  homeFormation: string;
  awayFormation: string;
  homeCoach: string;
  awayCoach: string;
  styles: MatchHubLineupsStyles;
}

export const MatchHubLineupsFormationStrip: React.FC<MatchHubLineupsFormationStripProps> = ({
  home,
  away,
  homeFormation,
  awayFormation,
  homeCoach,
  awayCoach,
  styles,
}) => (
  <View style={styles.formStrip}>
    <FormationBadge team={home} formation={homeFormation} coach={homeCoach} styles={styles} />
    <Text style={styles.formLabel}>FORMATION</Text>
    <FormationBadge team={away} formation={awayFormation} coach={awayCoach} styles={styles} away />
  </View>
);
